import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../../../components/toast/useToast";
import SetupService from "./SetupService";
import type { SetupRequest, SetupStatusResponse } from "../generated";
import { isMockActive } from "../../../utils/isMockActive";

// Query key constant
export const SETUP_STATUS_QUERY_KEY = ['setupStatus'];

// -----------------------------
// SETUP STATUS QUERY
// -----------------------------
export const useSetupStatusQuery = () => {
    return useQuery<SetupStatusResponse, Error>({
        queryKey: SETUP_STATUS_QUERY_KEY,
        queryFn: () => SetupService.getSetupStatus(),
        staleTime: Infinity, // Status won't change during session
        retry: 1,
        enabled: !isMockActive(),
    });
};

// -----------------------------
// SETUP MUTATION
// -----------------------------
export const useSetupMutation = () => {
    const { showToast } = useToast();
    const queryClient = useQueryClient();

    return useMutation<void, Error, SetupRequest>({
        mutationFn: (data) => SetupService.submitSetup(data),

        onSuccess: () => {
            // Immediately update setup status to false (no need to refetch)
            queryClient.setQueryData<SetupStatusResponse>(SETUP_STATUS_QUERY_KEY, { setupRequired: false });
            showToast("Aplikace byla úspěšně nastavena.", "success");
        },

        onError: (error) => {
            showToast(error.message || "Nastavení aplikace se nezdařilo.", "error");
        },
    });
};
